import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from 'carbon-components-react';

export default class TextField extends Component {
    render() {
        const { label, description, errors, ...other } = this.props,
            helperText = description && description() ? description() : false,
            type = other.type ? other.type : 'text';

        return (
            <div className='ht-field ht-textfield'>
                <TextInput
                    labelText={label}
                    helperText={helperText}
                    invalid={!!errors}
                    invalidText={errors}
                    {...other}
                    type={type}
                />
            </div>
        );
    }
}

TextField.defaultProps = {
    description: null,
    label: '',
    value: ''
};

TextField.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.func,
    label: PropTypes.string,
    value: PropTypes.string
};
